class SubscriptionUpsell extends HTMLElement {
  constructor() {
    super();

    this.selectOptions = this.querySelectorAll(".subscription-upsell__select");
    this.current_option = this.selectOptions[0].value;
    this.faqContainer = this.querySelector(".subscription-faq");
    this.faqButtons = this.querySelectorAll(
      ".subscription-upsell__more-informations"
    );
    this.closeFaq = this.querySelector(".subscription-faq__close");

    this.discount_after_orders = parseInt(
      this.getAttribute("data-discount-upsell-after")
    );

    this.switcherOneshot = false;

    this.selectOptions.forEach((select) => {
      select.addEventListener("change", (e) => {
        this.current_option = e.target.value;
        this.selectOptions.forEach((select) => {
          select.value = this.current_option;
        });
        this.updateCart();
      });
    });

    this.addEventListener("cart:reload", this.updateCart.bind(this));

    this.switchSubscribe = this.querySelector(
      ".subscription-upsell__subscribe"
    );
    this.switchOneShot = this.querySelector(".subscription-upsell__oneshot");

    this.divSubscribe = this.querySelectorAll(
      ".subscription-upsell__why, .subscription-upsell__subtitle, .subscription-upsell__subtotal-line:last-child"
    );

    this.faqButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        this.faqContainer.classList.remove("hidden");
      });
    });

    this.closeFaq.addEventListener("click", (e) => {
      e.preventDefault();
      this.faqContainer.classList.add("hidden");
    });

    this.cart_type = "oneshot";

    this.switchSubscribe.addEventListener("click", (e) => {
      e.preventDefault();
      this.switchSubscribeFt(e);
    });

    this.switchOneShot.addEventListener("click", (e) => {
      e.preventDefault();
      this.switchOneShotFt(e);
    });

    this.initSwitcherOneshot();

    // let has_decline_btn = document.querySelector(
    //   ".btn-checkout-subscription-decline"
    // );

    // if (has_decline_btn) {
    //   has_decline_btn.addEventListener("click", async (e) => {
    //     e.preventDefault();
    //     this.cart_type = "oneshot";
    //     await this.updateSellingPlans();
    //     document
    //       .querySelector(
    //         ".btn-checkout-subscription-decline + .btn-checkout-subscription"
    //       )
    //       .click();
    //   });
    // }

    this.initEvents();
  }

  initEvents() {
    this.addEventListener("subscription-upsell:oneshot", (e) => {
      this.switchOneShotFt(null, true);
    });

    this.addEventListener("subscription-upsell:subscribe", (e) => {
      this.switchSubscribeFt(null, true);
    });
  }

  switchSubscribeFt(e, nextStep = false) {
    this.cart_type = "subscribe";

    if (nextStep == false) {
      let switcher = this.querySelector(".switcher");
      switcher.classList.add("actif");
      this.switcherOneshot = false;
      this.current_option = this.selectOptions[0].value;
      this.switchOneShot.classList.remove("actif");
      e?.currentTarget.classList.add("actif");
      this.classList.add("subscription-upsell--subscribe");
      this.classList.remove("subscription-upsell--oneshot");
      this.divSubscribe.forEach((div) => {
        div.classList.remove("hidden");
      });
      document.querySelector(".oneshot-prices").style.display = "none";
      document.querySelector(".subscribe-prices").style.display = "flex";
    }
    this.updateCart(null, nextStep);
  }

  switchOneShotFt(e, nextStep = false) {
    this.cart_type = "oneshot";

    if (nextStep == false) {
      let switcher = this.querySelector(".switcher");
      switcher.classList.remove("actif");
      this.switcherOneshot = true;
      this.switchSubscribe.classList.remove("actif");
      e?.currentTarget.classList.add("actif");
      this.classList.add("subscription-upsell--oneshot");
      this.classList.remove("subscription-upsell--subscribe");
      this.divSubscribe.forEach((div) => {
        div.classList.add("hidden");
      });
      document.querySelector(".oneshot-prices").style.display = "block";
      document.querySelector(".subscribe-prices").style.display = "none";
      document
        .querySelector(".subscription-upsell__subtotal-line + div")
        .classList.add("hidden");
      this.querySelector(".switcher.actif")
        ? this.querySelector(".switcher.actif").click()
        : null;
    }
    this.updateCart(null, nextStep);
  }

  getCartTotalDividedBy3() {
    return (
      parseFloat(
        document
          .querySelector("[data-oneshot-upsell-total-price]")
          .innerHTML.replace("€", "")
      ) / 3
    ).toFixed(2);
  }

  getCartTotal(type = "oneshot") {
    let total = 0;

    if (this.cart_type == "oneshot" && type != "subscribe") {
      for (const product of this.upsellProducts) {
        total +=
          parseFloat(parseFloat(product.dataset.oneshotPrice)) *
          parseInt(product.querySelector(".input-quantity").value);
      }
    } else {
      for (const product of this.upsellProducts) {
        total +=
          parseFloat(parseFloat(product.dataset.subscribePrice)) *
          parseInt(product.querySelector(".input-quantity").value);
      }
    }

    return (total / 100).toFixed(2);
  }

  updateCart(e, nextStep = false) {
    if (e && "detail" in e) {
      if (e.detail.reloadSellingPlans) {
        this.updateSellingPlans(nextStep);
      }
    } else {
      this.updateSellingPlans(nextStep);
    }
  }

  initSwitcherOneshot() {
    let switcher = this.querySelector(".switcher");

    switcher.addEventListener("click", (e) => {
      e.preventDefault();

      let select = this.querySelector(
        ".subscription-upsell__switcher-bottom-content .select"
      );

      /** Switcher oneshot
       * Switch between oneshot and subscribe mode
       * update cart and switcher
       */

      if (this.switcherOneshot) {
        this.switcherOneshot = false;
        this.current_option = this.selectOptions[0].value;
        switcher.classList.add("actif");
        this.cart_type = "subscribe";
        select.classList.remove("hidden");
      } else {
        this.switcherOneshot = true;
        this.current_option = "oneshot";
        switcher.classList.remove("actif");
        this.cart_type = "oneshot";
        select.classList.add("hidden");
      }
      this.updateCart();
    });
  }

  async getProducts() {
    let res = await fetch("/cart.js")
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        return data.items;
      });

    return res;
  }

  async updateSellingPlans(nextStep = false) {
    this.classList.add("is-loading");
    document
      .querySelector(".sidecart__footer")
      .classList.add("sidecart__footer--loading");

    const products = await this.getProducts();
    let index = 1;

    for (let product of products) {
      let handle = product.handle;

      let plans_count = 0;

      if (window.selling_plans[handle] !== undefined) {
        plans_count = Object.keys(window.selling_plans[handle]["plans"]).length;
      }

      // if (!product.properties["_featured-product"]) {
      if (plans_count > 0 && this.cart_type == "subscribe") {
        let selling_plan =
          window.selling_plans[handle]["plans"][this.current_option];
        let quantity = product.quantity;

        if (selling_plan) {
          await this.fetchUpdateSellingPlans(index++, selling_plan, quantity);
        } else {
          index++;
        }
        //console.log(res);
      } else if (this.cart_type == "oneshot" && plans_count > 0) {
        let selling_plan = null;
        let quantity = product.quantity;

        await this.fetchUpdateSellingPlans(index++, selling_plan, quantity);
      } else {
        index++;
      }
    }

    // document
    //   .querySelector(".btn-checkout-subscription")
    //   .removeAttribute("disabled");

    // document
    //   .querySelector(".btn-checkout-subscription-decline")
    //   ?.removeAttribute("disabled");

    document.querySelector("side-cart").dispatchEvent(
      new CustomEvent("dispatch:cart-drawer:refresh", {
        detail: {
          nextStep: nextStep,
        },
      })
    );
  }

  wait(ms) {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  }

  fetchUpdateSellingPlans(line, selling_plan_id, quantity) {
    var url = "cart/change.js";

    let formData = {
      line: line,
      quantity: parseInt(quantity),
      selling_plan: null,
    };

    if (selling_plan_id) {
      formData.selling_plan = selling_plan_id;
    }
    return fetch(window.Shopify.routes.root + url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    }).then((response) => {
      return response.json();
    });
  }
}

customElements.define("subscription-upsell", SubscriptionUpsell);
